import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import App from './App'
import './styles/globals.css'

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>,
)

// Registers the push-notification service worker (public/sw.js). Guarded
// since not every browser supports it; registration itself doesn't request
// notification permission — that only happens when the operator opts in via
// the Settings push toggle (see lib/hooks/usePushSubscription.ts).
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js').catch((err) => {
      console.error('[main] Service worker registration failed:', err)
    })
  })
}
